import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { useTranslation } from 'react-i18next';

import { useAuthHeaders } from '@pletly/feature-auth';
import { Text, UserAvatarsStack, colors, spacing } from '@pletly/ui';
import { getName } from '@pletly/shared';
import { YourCommunityGroupsQuery } from '%screens/communities/your/components/__generated__/yourGroups.generated';

interface Props {
	users: YourCommunityGroupsQuery['currentUser']['memberOfCommunityGroups'][0]['members'];
}

const MAX_AVATARS = 4;
const AVATAR_SIZE = 24;

export const CommunityMembersInfo = ({ users }: Props) => {
	const { t } = useTranslation();
	const { getHeaders } = useAuthHeaders();
	const avatars = useMemo(
		() =>
			users.map(({ photoUrl, ...user }) => ({
				name: getName(user),
				photoSource: photoUrl ? { uri: photoUrl, headers: getHeaders(photoUrl) } : undefined,
			})),
		[users, getHeaders],
	);

	return (
		<View style={styles.root}>
			<UserAvatarsStack items={avatars} avatarSize={AVATAR_SIZE} maxAvatars={MAX_AVATARS} />

			<Text category="c1" style={styles.membersText}>
				{users?.length ? (
					<Text category="s2" style={styles.membersText}>
						{users?.length ?? ''}
					</Text>
				) : (
					t('common.no')
				)}{' '}
				{t('community.members')}
			</Text>
		</View>
	);
};

const styles = StyleSheet.create({
	root: {
		flexDirection: 'row',
		gap: spacing(0.5),
	},
	membersText: {
		color: colors.black600,
	},
});
